import React from 'react';

import { Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
    ReactHookFormInput,
    ReactHookFormSelect,
    ReactHookFormSelect2Multi,
} from 'common/components/form';
import {
    DEFAULT_PRODUCT_TYPES,
    DEFAULT_RATES,
    DEFAULT_TYPES_BUSINESS,
} from 'common/constants';

import Template from './Template';
import Terms from './Terms';

const CommonFields = ({ control, disabled }) => {
    const { t } = useTranslation();

    const rateOptions = [{ label: '', options: DEFAULT_RATES }];

    return (
        <Stack sx={{ mb: 2 }}>
            <ReactHookFormInput
                control={control}
                disabled={disabled}
                label={t('Product name')}
                name="name"
            />

            <ReactHookFormInput
                control={control}
                disabled={disabled}
                label={t('General information about the product')}
                multiline
                name="description"
            />

            <Template control={control} disabled={disabled} />

            <ReactHookFormSelect
                control={control}
                disabled={disabled}
                label={t('Product type')}
                name="type"
                options={DEFAULT_PRODUCT_TYPES}
            />

            <ReactHookFormSelect
                control={control}
                disabled={disabled}
                label={t('Type of tax regime')}
                name="types_business_company"
                options={DEFAULT_TYPES_BUSINESS}
            />

            <ReactHookFormSelect2Multi
                allTextValue={t('All text', { count: 2 })}
                control={control}
                disabled={disabled}
                fullWidth
                label={t('Select rates to consider')}
                multiple
                name="rate_list"
                options={rateOptions}
                size="normal"
            />

            <Terms
                control={control}
                disabled={disabled}
                label={t('Product terms')}
                name="parameters.terms"
            />
        </Stack>
    );
};

CommonFields.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
};

export default CommonFields;
